import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
export default function Footer() {
    const location = useLocation();
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-col">
                    <h3>About Us</h3>
                    <p>
                        Senthan Amuthan Kids Wear was founded in 2020 by Keerthana, a proud mom of two, with a vision to create clothing that truly understands families. What began as a personal need for comfortable and stylish outfits has grown into a brand offering all kinds of family wear. We focus on quality fabrics, thoughtful designs, and everyday comfort for every age.
                        At Senthan Amuthan, we believe clothing is more than just style — it’s about feeling confident and comfortable in every moment. Our mission is to make every individual feel at ease in any situation.
                    </p>
                </div>
                <div className="footer-col">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/return-policy">Return Policy</Link></li>
                        <li><Link to="/terms-and-condition">Terms & Condition</Link></li>
                        <li>
                            <div className="social-icons">
                                <a href="https://www.instagram.com/senthan_amuthan_kids_wear?igsh=MWFzbnQ4Y3AyamY2MA==" target="_blank" rel="noopener noreferrer">
                                    <FaInstagram />
                                </a>
                                <a href="https://www.facebook.com/share/18drJPH74i/" target="_blank" rel="noopener noreferrer">
                                    <FaFacebook />
                                </a>
                                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                                    <FaYoutube />
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>

            <div className="footer-bottom">
                © {new Date().getFullYear()} Website Developed By{" "}
                <a href="https://www.praneeshinfotech.com" target="_blank" rel="noopener noreferrer">
                    Praneesh Infotech
                </a>. All Rights Reserved.
            </div>
        </footer>
    );
}